module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/229.237e1695.png";